import { createReducer } from "../../app/common/util/reducerUtil";
import { FETCH_WUC_TRANSACTIONS } from "./wucConstants";

const initialState = [];

export const getTransactionsForDashboard = (state, payload) => {
  // console.log('payload',payload)

  return payload.transactions;
};

export default createReducer(initialState, {
  [FETCH_WUC_TRANSACTIONS]: getTransactionsForDashboard,
});
